import Watch from './watch.webp';
import AP from './airpurifier.webp';
import Book from './book.webp';
import Chair from './chair.webp';
import Headphones from './headphones.webp';
import Mouse from './mouse.webp';
import Tent from './tent.webp';
import TM from './treadmill.webp';
import TV from './tv.webp';
import Sale from './sale.webp';

export const images = {
  AP,
  Watch,
  Book,
  Chair,
  Headphones,
  Mouse,
  Tent,
  TM,
  TV,
  Sale,
};
